export const SalesFormat = {
  UNIDADE: 'Unidade',
  CAIXA: 'Caixa',
};

export const isUnitySalesFormat = salesFormat =>
  salesFormat === SalesFormat.UNIDADE;
